import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { useMeta } from '@/stores/meta.js'

/**
 * Phone numbers as they are commonly written, with the country's prefix (D-227): "+48 600 100
 * 200", "+49 30 1234567" — as Core keeps the numbers saved since. A number without a prefix is
 * read as one of `country` (a record's), else of the company's own (home_country); what
 * cannot be read as a valid number is shown as it was typed.
 */
export function homeCountry() {
  try {
    return String(useMeta().data?.home_country || 'PL').toUpperCase()
  } catch {
    return 'PL'
  }
}

function parse(raw, country) {
  const value = String(raw ?? '').trim()
  if (!value) return null
  const number = parsePhoneNumberFromString(value, (country || homeCountry()).toUpperCase())
  return number?.isValid() ? number : null
}

/** For the eye: the international format, or the text as typed. */
export function formatPhone(raw, country = null) {
  const number = parse(raw, country)
  return number ? number.formatInternational() : String(raw ?? '').trim()
}

/** For a link that dials: "tel:+48600100200" (E.164), or the digits typed. */
export function telHref(raw, country = null) {
  const number = parse(raw, country)
  return `tel:${number ? number.number : String(raw ?? '').replace(/[^\d+]/g, '')}`
}
